import React, { useState, useEffect } from "react";
import { GoSearch } from "react-icons/go";
import { useDispatch, useSelector } from "react-redux";
import { getCartDetails, getAllPackageList } from "../../Redux/Actions";
import { Link, useHistory } from "react-router-dom";
import { HiSearch } from "react-icons/hi";

import { BiCartAlt } from "react-icons/bi";
import "../SearchBar/Searchbar.css";
import Loader from "../Loader/Loader";
import { set } from "js-cookie";
function Searchbar() {
  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const history = useHistory();
  const [cartLen, setCartLen] = useState(0);
  const [loading, setLoading] = useState(true);
  const [showSearch, setShowSearc] = useState(false);
  const AllpackageList = useSelector((state) => state.allpackage);
  const { loading: packloading, AllpackDetail } = AllpackageList;

 

  //getiing cart details
  const cartDetails = useSelector((state) => state.CartReducer);
  const { loading: cartLoading, cartDetails: cartdata } = cartDetails;
 
  useEffect(() => {
    if(JSON.parse(localStorage.getItem("user"))){
      const userProfile = JSON.parse(localStorage.getItem("user"));
      dispatch(getCartDetails(userProfile?.token, citySelect));
    } 
  },[]);
  const [Div, setDiv] = useState(true);
  const dispatch = useDispatch();
  const [searchTerm, setSearchTerm] = useState("");
  const [firstpackSlug, setFirstpackSlug] = useState("");

  const handleOnChange = (e) => {
    setDiv(true);
    setSearchTerm(e.target.value);

    if (e.target.value.length > 2) {
      setShowSearc(true);
      dispatch(getAllPackageList(e.target.value, citySelect));
    }
  };

  const hideDiv = (cityName) => {
    setSearchTerm(cityName);
    setDiv(false);
  };

  //USER DETAILS
  const [userDetails, setUserDetails] = useState([]);

  //Getting data from localhost
  useEffect(() => {
    const userProfile = JSON.parse(localStorage.getItem("user"));

    setUserDetails(userProfile);
  }, []);
  // useEffect(() => {
  //   setFirstpackSlug(AllpackDetail?.results ? AllpackDetail?.results[0]?.slug : "full-body-checkup-with-rtpcr")
  // }, [AllpackDetail?.results])

  const getAllPackage = (e) => {
    e.preventDefault();
    // console.log(e.target[0].defaultValue);
    const inputQuery = e.target[0].defaultValue;
    console.log(citySelect.toLowerCase());
    history.push({
      pathname: `/health-checkup-packages`,

      state: [AllpackDetail.results],
    });
    setSearchTerm("");
  };

  useEffect(() => {
    cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] &&
      cartDetails.cartDetails[0].product.length &&
      setCartLen(
        cartDetails.cartDetails[0].product !== "" &&
          cartDetails.cartDetails[0].product.length > 0
          ? cartDetails.cartDetails[0].product.length
          : 0
      );
  }, [cartDetails]);
  return (
    <div className="header__Search">
      <div className="cartIcon">
        {userDetails ? (
          <span className="font-design CartBorder">
            <Link to="/cart">
              <BiCartAlt />
              {cartLen > 0 ? (
                <span className="count">
                  {cartDetails &&
                    cartDetails.cartDetails &&
                    cartDetails.cartDetails[0] &&
                    cartDetails.cartDetails[0].product.length > 0 &&
                    cartDetails &&
                    cartDetails.cartDetails &&
                    cartDetails.cartDetails[0] &&
                    cartDetails.cartDetails[0].product.length}
                </span>
              ) : null}
            </Link>
          </span>
        ) : null}
      </div>
      <div className="mainSearchForm">
        <span className="header__SearchIcon">
          <HiSearch />
        </span>
        <form className="headerForm" onSubmit={getAllPackage}>
          <input
            className="enter"
            value={searchTerm}
            placeholder="Search for health package or tests"
            onChange={handleOnChange}
          ></input>
          {/**search icon */}

          <div>
            {/* <Link to={`/${firstpackSlug}-${citySelect.toLowerCase()}`}> */}
            <button type="submit" className="headerSubmitBtn searchButton">
              <HiSearch /> Search
            </button>
            {/* </Link> */}
          </div>
        </form>
      </div>
      {searchTerm == "" ? null : Div ? (
        searchTerm.length > 3 ? (
          <div className="searchedData">
            {packloading ? (
              <Loader />
            ) : AllpackDetail && AllpackDetail.results.length < 1 ? (
              <h2>No Packages found</h2>
            ) : (
              AllpackDetail &&
              AllpackDetail.results.map((value) => {
                return (
                  <Link
                    to={`/${value.slug}${citySelect ? `-${citySelect
                  .toLowerCase()}` : ''}`}
                    onClick={() => {
                      hideDiv(value.name);
                    }}
                    className="searchLink"
                  >
                    {value.name}
                  </Link>
                );
              })
            )}
          </div>
        ) : null
      ) : null}
    </div>
  );
}

export default Searchbar;
